import { BaseModule } from "by/gamefactory/cityversetycoon/composition/module/BaseModule";
import { ShopModuleFlowExecutor } from "./ShopModuleFlowExecutor";
import { ShopPopupScene } from "./scene/ShopPopupScene";
import { ShopController } from "./controller/ShopController";
import { ShopModel } from "./model/ShopModel";
import { ShopResourcePackage } from "./resources/ShopResourcePackage";
import { ParamDescription } from "by/gamefactory/cityversetycoon/composition/module/ParamDescription";
import { CancellationToken } from "async/CancellationToken";


export class ShopModule extends BaseModule<void> {
    private shopResourcePackage: ShopResourcePackage;

    public override async build(): Promise<void> {
        this.internalContainer.register(ShopModuleFlowExecutor, ShopModuleFlowExecutor);

        this.internalContainer.register(ShopPopupScene, ShopPopupScene);
        this.internalContainer.register("ShopPopupSceneFactory", {
            useValue: async (cancellationToken: CancellationToken) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    ShopPopupScene,
                    new ParamDescription(CancellationToken, cancellationToken));
            }
        })

        this.internalContainer.register("IShopController", ShopController);
        this.internalContainer.registerSingleton("IShopModel", ShopModel);

        this.shopResourcePackage = new ShopResourcePackage();
        await this.shopResourcePackage.load();
        this.internalContainer.registerInstance(ShopResourcePackage, this.shopResourcePackage);

        await super.build();
    }

    public async start(): Promise<void> {
        const executor = await this.internalContainer.resolve(ShopModuleFlowExecutor);
        await executor.execute(this);
        this.dispose();
    }

    public override dispose(): void {
        this.shopResourcePackage.destroy();
        super.dispose();
    }
}